import { hasLabels, setLabels } from '@insight/toolkit-utils/lib/labels'

// A helper function for passing down application labels ref returned from i18n function.
// This will resolve toolkit-react translation issues when a different version of toolkit-utils is used from the application
// Since labels is an object, setLabels will point to the same object reference being passed in from the application instead of duplicating the labels in toolkit
export default function setToolkitLabels(labels) {
  if (!hasLabels()) {
    console.log('setting toolkit to application labels')
    setLabels(labels)
  }
}
